type AssistQuoteLineProps = {
  /** Who said the quote; omitted when the segment could not be attributed. */
  speaker: string | null
  /** Pre-formatted `mm:ss` label, or `null` when the moment is unknown. */
  timestamp: string | null
  quote: string
}

/**
 * A verbatim transcript turn, rendered as `Speaker 2 · 05:01 – “…”`. Owns the
 * header row of a quote card, so the live-turn card and a suggestion's own quote
 * groups cannot drift apart.
 *
 * Either leading part can be missing (an unattributed segment, or one whose
 * timestamp was not reported), so both are dropped along with the separator
 * rather than printed as a placeholder. The quote itself is always shown whole:
 * it is the context the reader needs, not a summary to expand.
 */
export default function AssistQuoteLine({ speaker, timestamp, quote }: AssistQuoteLineProps) {
  const moment = [speaker, timestamp].filter(Boolean).join(' · ')

  return (
    <p className="min-w-0 flex-1 text-[11px] leading-[16.5px]">
      {moment ? (
        <span className="font-bold text-[#065f46] dark:text-emerald-300">{moment}</span>
      ) : null}
      {moment ? ' – ' : null}
      {/* Secondary on purpose. The quote and the question under it used to
          be the same size and the same ink, so nothing told the eye which of
          the two could be pressed. */}
      <span className="text-slate-500 dark:text-[var(--text-tertiary)]">
        &ldquo;{quote}&rdquo;
      </span>
    </p>
  )
}
